import React from "react";
import _ from "lodash";

import FormattedCurrencyValue from "../fields/number/FormattedCurrencyValue";
import CURRENCIES from "../selectors/currency/currencies.json";
import LANGUAGES_CONTROLLER from "../../controllers/languages";
import Logger from "../../utils/logger";
import { withFullStoryExclude } from "../../utils/fullStoryHelper";

const log = new Logger("REACT_COMPONENT_HELPER");

export function getCurrencyColumnOptions({ isSensitive = false } = {}) {
    log.debug("getCurrencyColumnOptions() : ");
    const currencyColumnOptions = {
        Cell: (row) => {
            if (!row) {
                return <span></span>;
            }
            return (
                <span>
                    <FormattedCurrencyValue
                        inputFieldClassName={isSensitive ? withFullStoryExclude() : ""}
                        value={row.value}
                    ></FormattedCurrencyValue>
                </span>
            );
        },
        filterable: true,
        filterMethod: (filter, row, column) => {
            let valueAsNum = Number.parseFloat(filter.value, 10);
            return valueAsNum === row[filter.id];
        },
        sortMethod: (a, b, desc) => {
            // force null and undefined to the bottom
            a = Number.parseFloat(a, 10);
            b = Number.parseFloat(b, 10);
            a = Number.isNaN(a) ? -Infinity : a;
            b = Number.isNaN(b) ? -Infinity : b;
            // Return either 1 or -1 to indicate a sort priority
            if (a > b) {
                return 1;
            }
            if (a < b) {
                return -1;
            }
            // returning 0 or undefined will use any subsequent column sorting methods or the row index as a tiebreaker
            return 0;
        },
        className: isSensitive ? withFullStoryExclude("text-align-right"): "text-align-right",
    };
    return currencyColumnOptions;
}

export function getCurrencyByCountryCode(countryCode) {
    if (typeof countryCode !== "string" || _.isEmpty(countryCode)) {
        return null;
    }
    return CURRENCIES.find((currency) => {
        return currency.countryCode === countryCode;
    });
}

export function getCurrencies(customItems = []) {
    const currencyIdSelector = (currency) => currency.currencyCode;
    const currencyItems = _.sortBy(_.uniqBy(CURRENCIES, currencyIdSelector), currencyIdSelector);
    return _.isEmpty(customItems)
        ? currencyItems
        : _.isArray(customItems)
        ? customItems.concat(currencyItems)
        : [customItems].concat(currencyItems);
}

export function getEnumBy(enumType, value, languages, key = "languageString") {
    log.debug("getEnumBy() - enumType: %s, value: %s, key: %s", enumType, value, key);
    if (!enumType || !languages) {
        return null;
    }
    let matchedEnumType = enumType.enumValues.find((enumEntry) => {
        if (key === "languageString") {
            return LANGUAGES_CONTROLLER.format(languages, enumEntry[key]) === value;
        } else if (key === "name") {
            return enumEntry.name === value;
        }
    });
    if (matchedEnumType) {
        return matchedEnumType;
    } else {
        return null;
    }
}

export function findCompanyBy(key = "id", value = "", companyList = []) {
    let matchedCompany = companyList.find((company) => {
        return `${company[key]}` === `${value}`;
    });
    return matchedCompany;
}
/**
 * Formats the given number to currency.  Null is returned if the provided value is not a valid number.
 *
 * @param {*} number
 * @returns Null || Number
 */
export function formatToCurrency(number) {
    const currencyValue = parseFloat(number);
    const invalidNumber = isNaN(currencyValue);
    log.debug("formatToCurrency(): ", currencyValue, invalidNumber);
    const formattedNumber = invalidNumber ? null : currencyValue.toFixed(2);
    log.debug("formatToCurrency(): ", formattedNumber);
    return formattedNumber;
}

export default {
    getCurrencyColumnOptions,
    getCurrencyByCountryCode,
    getEnumBy,
    findCompanyBy,
    formatToCurrency,
    getCurrencies,
};
